<div class="d-flex flex-column gap-2">
  <div class="d-flex justify-content-between align-items-center">
    <div class="text-uppercase text-secondary fw-semibold small">Beneficiarios de la póliza</div>
    <small class="text-muted">Los porcentajes deben sumar 100%</small>
  </div>

  @for (group of formArray.controls; track group; let i = $index) {
  <div class="border rounded-3 p-2" [formGroup]="group">
    <div class="d-flex justify-content-between align-items-center mb-1">
      <span class="small fw-semibold">Beneficiario {{ i + 1 }}</span>
      <button (click)="remove(i)" [attr.aria-label]="'Eliminar beneficiario ' + (i + 1)"
        class="btn btn-sm btn-outline-danger border-0 rounded-circle p-1" type="button">
        <app-icon name="trash-2" [size]="18" [strokeWidth]="2" color="currentColor"></app-icon>
      </button>
    </div>
    <div class="row g-1">
      <div class="col-12 col-md-6">
        <div class="form-floating">
          <input [id]="idPrefix + '-name-' + i" [class.is-invalid]="isInvalid(group, 'name')"
            class="form-control focus-ring focus-ring-light" formControlName="name" maxlength="40" placeholder=" "
            type="text">
          <label [for]="idPrefix + '-name-' + i">Nombres</label>
          <div class="invalid-feedback">El campo nombres es obligatorio.</div>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="form-floating">
          <input [id]="idPrefix + '-lastName-' + i" [class.is-invalid]="isInvalid(group, 'lastName')"
            class="form-control focus-ring focus-ring-light" formControlName="lastName" maxlength="40" placeholder=" "
            type="text">
          <label [for]="idPrefix + '-lastName-' + i">Apellidos</label>
          <div class="invalid-feedback">El campo apellidos es obligatorio.</div>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="form-floating">
          <select (change)="onDocumentTypeChange(group)" [id]="idPrefix + '-documentType-' + i"
            [class.is-invalid]="isInvalid(group, 'documentType')" aria-label="Tipo de documento"
            class="form-select focus-ring focus-ring-light" formControlName="documentType">
            <option [ngValue]="'IdCard'">Cédula</option>
            <option [ngValue]="'Passport'">Pasaporte</option>
          </select>
          <label [for]="idPrefix + '-documentType-' + i">Tipo de documento</label>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="form-floating">
          <input [id]="idPrefix + '-documentNumber-' + i" [class.is-invalid]="isInvalid(group, 'documentNumber')"
            [mask]="documentMask(group)" class="form-control focus-ring focus-ring-light"
            formControlName="documentNumber" placeholder=" " type="text">
          <label [for]="idPrefix + '-documentNumber-' + i">No. de documento</label>
          <div class="invalid-feedback">
            @if (group.get('documentNumber')?.hasError('passportLength')) {
            El pasaporte debe tener entre 5 y 12 caracteres.
            } @else {
            El número de documento es obligatorio.
            }
          </div>
        </div>
      </div>
      <div class="col-12 col-md-8">
        <div class="form-floating">
          <select [id]="idPrefix + '-relationship-' + i" [class.is-invalid]="isInvalid(group, 'relationship')"
            aria-label="Parentesco" class="form-select focus-ring focus-ring-light" formControlName="relationship">
            <option [ngValue]="null" disabled>Selecciona una opción</option>
            @for (r of relationships; track r.value) {
            <option [ngValue]="r.value">{{ r.label }}</option>
            }
          </select>
          <label [for]="idPrefix + '-relationship-' + i">Parentesco</label>
          <div class="invalid-feedback">Debe seleccionar el parentesco.</div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="form-floating">
          <input [id]="idPrefix + '-percentage-' + i" [class.is-invalid]="isInvalid(group, 'percentage')"
            class="form-control focus-ring focus-ring-light" formControlName="percentage" inputmode="decimal"
            mask="separator.2" separatorLimit="100" placeholder=" " suffix="%" type="text">
          <label [for]="idPrefix + '-percentage-' + i">Porcentaje</label>
          <div class="invalid-feedback">Indique un porcentaje entre 0.01 y 100.</div>
        </div>
      </div>
    </div>
  </div>
  }

  <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
    <button (click)="add()" class="btn btn-sm btn-outline-secondary rounded-pill d-flex align-items-center gap-1"
      type="button">
      <app-icon name="user-plus" [size]="16" [strokeWidth]="2" color="currentColor"></app-icon>
      Agregar beneficiario
    </button>
    @if (formArray.length > 0) {
    <span [class.text-danger]="formArray.hasError('percentageSum')" class="small fw-semibold">
      Total: {{ total }}%
    </span>
    }
  </div>
  @if (showArrayErrors && formArray.hasError('minBeneficiaries')) {
  <div class="text-danger small">Debe agregar al menos un beneficiario.</div>
  }
  @if (showArrayErrors && formArray.hasError('percentageSum')) {
  <div class="text-danger small">Los porcentajes de los beneficiarios deben sumar 100%.</div>
  }
</div>
